import React from 'react';
import { Modal } from 'react-bootstrap';
import { useModal } from '../../ModalContext';
import Login from "../Form/Login";

const FirstModal = () => {
    const { activeModal, handleFirstModalClose, handleSecondModalOpen, handleThirdModalOpen } = useModal();
  
    return (
      <Modal show={activeModal === 'first'} onHide={handleFirstModalClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Login />
        </Modal.Body>
      </Modal>
    );
  };
  

export default FirstModal;
